import React, { FC, useMemo } from 'react';
import { CohortDTOTypeEnum, OperationDTO, PlanDTO } from '@atlassiansox/phobos-client-ts';
import EmptyState from '@atlaskit/empty-state';
import groupBy from 'lodash/groupBy';

import { flex, flexDirectionColumn, extendWidth, spaceTopComfortable } from '@/styles';

import { cohortTypeSorted } from '../slo-panel/types';

import ActionBar from './action-bar';
import OperationCohort from './operation-cohort';

type SyncPanelProps = {
  data: PlanDTO;
  name: string;
  inProgress: boolean;
};

const SyncPanel: FC<SyncPanelProps> = ({ data, name, inProgress }) => {
  const operations: OperationDTO[] = data?.operations || [];
  const groupedOperations = useMemo(() => groupBy(operations, 'groupType'), [operations]);

  if (inProgress) {
    return <EmptyState header="" description="An open sync operation is in progress..." />;
  }

  if (!data?.hash || operations.length === 0) {
    return (
      <EmptyState
        header=""
        description="No pending sync operations for this SLO group"
        imageUrl="/static/not-found.svg"
      />
    );
  }

  return (
    <div css={[flex, flexDirectionColumn, extendWidth]}>
      <ActionBar name={name} hash={data.hash} />
      {cohortTypeSorted.map((type: CohortDTOTypeEnum) => {
        const grouped = groupedOperations[type];
        if (!grouped) return null;
        return (
          <div key={type} css={spaceTopComfortable}>
            <OperationCohort operations={grouped} cohort={type} />
          </div>
        );
      })}
    </div>
  );
};

export default SyncPanel;
